<template>
    <div id="config-tiles">
        <FilterView placeholder="Chercher un serveur de tuiles..." v-model="searchTerm">
            <CustomButton
                v-if="selected.length"
                icon="trash-alt"
                class="default red-theme"
                @click="showConfirmMany = true"
            >
                Supprimer
            </CustomButton>
            <CustomButton icon="plus" class="default green-theme" @click="handleNew">
                Ajouter un serveur de tuiles
            </CustomButton>
        </FilterView>
        <Modal v-if="showEdit" v-model="layer" @dismiss="showEdit = false" @close="handleClose" />
        <Confirm v-if="showConfirmOne" @dismiss="showConfirmOne = false" @close="handleDeleteOne">
            <span slot="header">Supprimer le serveur de tuiles</span>
            <span slot="body">
                Êtes-vous sûr de vouloir supprimer ce serveur de tuiles ?<br />
                Les utilisateurs n'auront plus accès à cette couche sur la vue carte.
            </span>
        </Confirm>
        <Confirm
            v-if="showConfirmMany"
            @dismiss="showConfirmMany = false"
            @close="handleDeleteMany"
        >
            <span slot="header">Supprimer {{ selected.length }} serveur(s) de tuiles</span>
            <span slot="body">
                Êtes-vous sûr de vouloir supprimer tous les serveurs de tuiles sélectionnés ?<br />
                Les utilisateurs n'auront plus accès à ces couches sur la vue carte.
            </span>
        </Confirm>
        <h2 class="title">Serveurs de tuiles</h2>
        <LoadingDots v-if="isLoading" />
        <CardPager>
            <LayerCard
                v-for="item in filtered"
                :item="item"
                :key="item.id"
                :handleEdit="handleEdit"
                :handleConfirm="handleConfirm"
                :selected="selected"
                @selected="handleSelect"
            />
        </CardPager>
    </div>
</template>

<script>
import FilterView from '@/components/config/Filter';
import Modal from '@/components/config/ModalTile';
import Confirm from '@/components/config/DeleteConfirm';
import CustomButton from '@/components/Button';
import LoadingDots from '@/components/LoadingDots';
import CardPager from '@/components/CardPager';
import LayerCard from '@/components/config/LayerCard';

export default {
    data() {
        return {
            showEdit: false,
            showConfirmOne: false,
            showConfirmMany: false,
            layers: [],
            layer: null,
            searchTerm: null,
            isLoading: true,
            selected: [],
        };
    },
    computed: {
        filtered() {
            if (this.searchTerm) {
                const re = new RegExp(this.searchTerm, 'i');
                return this.layers.filter((l) => re.test(l.name));
            }
            return this.layers;
        },
    },
    mounted() {
        this.$http.get('/api/tile').then(
            (response) => {
                // success callback
                this.layers = response.body;
                this.isLoading = false;
            },
            (response) => {
                // error callback
                console.log(JSON.stringify(response));
                this.isLoading = false;
            },
        );
    },
    methods: {
        _getLayer(id) {
            const layer = this.layers.find((l) => l.id === id);
            return {
                ...layer,
            };
        },
        handleSelect(event) {
            const { id, checked } = event;
            const index = this.selected.findIndex((s) => s === id);
            if (checked) {
                if (index === -1) {
                    this.selected.push(id);
                }
            } else {
                if (index > -1) {
                    this.selected.splice(index, 1);
                }
            }
        },
        handleConfirm(item) {
            this.layer = this._getLayer(item);
            this.showConfirmOne = true;
        },
        handleEdit(item) {
            this.layer = this._getLayer(item);
            this.showEdit = true;
        },
        handleClose() {
            // Crée le nouveau flux, si les paramètres obligatoires sont renseignés
            if (!this.layer.id && this.layer.name && this.layer.url && this.layer.format) {
                this.$http
                    .post('/api/tile', this.layer)
                    .then((response) => {
                        const layer = response.body;
                        this.layers.push(layer);
                        this.showEdit = false;
                        this.layer = null;
                    })
                    .catch();
                // Met à jour le flux, si le nom du flux est renseigné
            } else if (this.layer.id && this.layer.name && this.layer.url && this.layer.format) {
                this.$http
                    .put(`/api/tile/${this.layer.id}`, this.layer)
                    .then((response) => {
                        const layer = response.body;
                        const index = this.layers.findIndex((l) => l.id === layer.id);
                        this.layers.splice(index, 1, layer);
                        this.showEdit = false;
                        this.layer = null;
                    })
                    .catch();
            }
        },
        handleNew() {
            this.layer = {
                id: null,
                name: '',
                url: null,
                layer: null,
                format: null,
                attribution: null,
            };
            this.showEdit = true;
        },
        handleDeleteOne() {
            this.$http
                .delete(`/api/tile/${this.layer.id}`)
                .then(() => {
                    const index = this.layers.findIndex((l) => l.id === this.layer.id);
                    this.layers.splice(index, 1);
                    this.showConfirmOne = false;
                    this.layer = null;
                })
                .catch();
        },
        handleDeleteMany() {
            const requests = this.selected.map((s) => this.$http.delete(`/api/tile/${s}`));
            Promise.all(requests)
                .then(() => {
                    this.showConfirmMany = false;
                    this.selected.splice(0);
                    this.isLoading = true;
                    return this.$http.get('/api/tile');
                })
                .then((response) => {
                    // success callback
                    this.layers = response.body;
                })
                .catch(() => {})
                .finally(() => (this.isLoading = false));
        },
    },
    components: {
        Modal,
        Confirm,
        CustomButton,
        FilterView,
        LoadingDots,
        CardPager,
        LayerCard,
    },
};
</script>

<style lang="scss"></style>
